<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_merchant_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.logo')"
            @selectImage="selectImage"
            disabled
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.store_name')"
            v-model.trim="data.store_name"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <!-- End:: Phone Input -->

          <!-- Start:: website Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.website')"
            v-model.trim="data.website"
            disabled
          />
          <!-- End:: website Input -->

          <!-- Start:: points_count Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points_count')"
            v-model.trim="data.points_count"
            disabled
          />
          <!-- End:: points_count Input -->

          <!-- Start:: points_value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points_value')"
            v-model.trim="data.points_value"
            disabled
          />
          <!-- End:: points_value Input -->

          <!-- Start:: desc Input -->
          <base-input
            col="7"
            rows="4"
            type="textarea"
            :placeholder="$t('SIDENAV.providers.description')"
            v-model.trim="data.desc"
            disabled
          />
          <!-- End:: desc Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateAdmin",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        store_name: null,
        points_count: null,
        points_value: null,
        desc: null,
        email: null,
        phone: null,
        website: null,
        password: null,
        passwordConfirmation: null,
        whatsApp: null,
        areas: [],
        active: true,
      },
      allAreas: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `vendors/${this.$route.params.id}`,
        });

        this.data.image.path = res.data.data.Vendor?.avatar;
        this.data.store_name = res.data.data.Vendor?.name;

        this.data.points_count = res.data.data.Vendor?.points;
        this.data.points_value = res.data.data.Vendor?.points_value;
        this.data.desc = res.data.data.Vendor?.description;
        this.data.website = res.data.data.Vendor?.website;
        this.data.email = res.data.data.Vendor?.email;
        this.data.phone = res.data.data.Vendor?.mobile;
        this.data.active = res.data.data.Vendor?.is_active;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
